import { readOnlyKey } from '../utils/keys';

export default {
    inject: {
        readOnlyInjected: { from: readOnlyKey },
    },
    computed: {
        readOnly () {
            return this.readOnlyInjected.value;
        },
    },
};
